export const language: any = {
    LabelCarts: "Panier d'achat",
    Material: "Matériau",
    nodata: "Aucune donnée dans le panier",
};